// extracted by mini-css-extract-plugin
export default {"statistics":"Statistics_statistics__MHVAH","statList":"Statistics_statList__mAfHM","item":"Statistics_item__5jALf"};